export class Trace {
  constructor(private readonly id: number, private readonly name: string, private readonly size: number | null) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getSize() {
    return this.size ?? 0;
  }
}
